var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { SubmissionTable, useFormioContext, Form, } from "@formio/react";
import { Utils } from "@formio/js";
const components = {
    Container: ({ children }) => _jsx("div", { className: "table-wrap", children: children }),
    TableContainer: ({ children }) => (_jsx("div", { className: "table remember-focus-table", children: children })),
    TableHeadContainer: ({ children }) => _jsx("div", { children: children }),
    TableHeaderRowContainer: ({ children }) => (_jsx("div", { className: "trow heading", children: children })),
    TableHeadCell: ({ children }) => _jsx("div", { className: "tcol", children: children }),
    TableBodyRowContainer: ({ children, onClick }) => (_jsx("div", { className: "trow entry", onClick: onClick, children: children })),
    TableBodyContainer: ({ children }) => _jsx("div", { children: children }),
    TableCell: ({ children }) => _jsx("div", { className: "tcol", children: children }),
    PaginationContainer: ({ children }) => (_jsx("div", { className: "table-pagination", children: _jsx("div", { className: "table-pagination-controls", children: children }) })),
    PaginationButton: ({ children, isActive, onClick, disabled }) => (_jsx("a", { className: `pagination-btn${isActive ? " active" : ""}${disabled ? " disabled" : ""}`, onClick: onClick, children: children })),
};
export const ViewData = ({ formId }) => {
    const [submission, setSubmission] = useState(null);
    const { Formio, token } = useFormioContext();
    const handleSubmissionRowClick = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const formio = new Formio(`${Formio.projectUrl || Formio.baseUrl}/form/${formId}/submission/${id}`);
        try {
            const submission = yield formio.loadSubmission();
            setSubmission(submission);
        }
        catch (err) {
            console.log("Error while loading submission:", err);
        }
    });
    const handleDeleteSubmission = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!submission) {
            return;
        }
        const formio = new Formio(`${Formio.projectUrl || Formio.baseUrl}/form/${formId}/submission/${submission._id}`);
        try {
            yield formio.deleteSubmission();
            setSubmission(null);
        }
        catch (err) {
            console.log("Error while deleting submission:", err);
        }
    });
    const handleExport = (exportType) => __awaiter(void 0, void 0, void 0, function* () {
        const filename = `${formId}-submissions.${exportType}`;
        try {
            const queryString = `?format=${exportType}&timezone=${encodeURIComponent(Utils.currentTimezone())}${exportType === "csv" ? "&view=formatted" : ""}`;
            const response = yield fetch(`/form/${formId}/export${queryString}`, { headers: { "x-jwt-token": token } });
            if (!response.ok) {
                throw new Error(`Error fetching data: ${response.statusText}`);
            }
            if (exportType === "json") {
                const data = yield response.json();
                const blob = new Blob([JSON.stringify(data, null, 2)], {
                    type: "application/json",
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                // Append the link to the document body (necessary for Firefox)
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
            else if (exportType === "csv") {
                const blob = yield response.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
        }
        catch (error) {
            console.error("Error downloading the JSON file:", error);
        }
    });
    return (_jsxs("div", { className: "panel view-data active", children: [_jsxs("div", { className: "button-wrap export", children: [_jsxs("button", { className: "button export-json small withiconright", onClick: () => handleExport("json"), children: ["Export JSON ", _jsx("i", { className: "ri-download-2-line" })] }), _jsxs("button", { className: "button export-csv small withiconright", onClick: () => handleExport("csv"), children: ["Export CSV ", _jsx("i", { className: "ri-download-2-line" })] }), _jsxs("button", { className: "button commercial pdf small withicon", children: [_jsx("img", { src: "icon-formio-small.svg", alt: "Form.io Icon" }), "Print To PDF"] }), _jsxs("div", { className: "helptext", children: ["To flag which fields appear in the table below, click", " ", _jsx("span", { className: "strong italic", children: "Edit Form" }), " above, view the ", _jsx("span", { className: "strong italic", children: "Settings" }), " for any one field, then toggle the", " ", _jsx("span", { className: "strong italic", children: "Table View" }), " checkbox."] })] }), submission ? (_jsxs(_Fragment, { children: [_jsx(SubmissionTable, { submissions: [submission], formId: formId, limit: 10, components: Object.assign(Object.assign({}, components), { PaginationButton: ({ children, isActive }) => (_jsx("a", { className: `pagination-btn disabled${isActive ? " active" : ""}`, children: children })) }) }), _jsxs("div", { className: "entry-details-wrap active", children: [_jsxs("div", { className: "entry-details-menu-wrap", children: [_jsx("button", { className: "close-button close-entry-details", onClick: () => setSubmission(null), children: _jsx("i", { className: "ri-close-line" }) }), _jsxs("button", { className: "button pink small open-lightbox", onClick: handleDeleteSubmission, children: ["Delete", " ", _jsx("span", { className: "longword", children: "Submission" })] })] }), _jsx("div", { className: "entry-details-content edit-submission active", children: _jsx(Form, { submission: submission, src: `/form/${formId}`, onSubmitDone: () => setSubmission(null) }) })] })] })) : (_jsx(SubmissionTable, { onSubmissionClick: handleSubmissionRowClick, limit: 10, formId: formId, components: components }))] }));
};
